import {
  APIComponentAttributes,
  APIParentChildReferenceAttributes,
  APIReferenceAttributes,
  FEParentChildReferenceAttributes,
  MagicReferenceTypes,
} from '@ardoq/api-types';

// Return the parent child reference in BE format. It is currently not
// satisfying the APIReferenceAttributes type.
export const componentToParentChildReferenceInBEFormat = ({
  _id,
  parent,
  rootWorkspace,
  model,
}: APIComponentAttributes & { parent: string }) =>
  ({
    _id: `${_id}:${parent}`,
    type: -1,
    rootWorkspace,
    source: _id,
    targetWorkspace: rootWorkspace,
    target: parent,
    ardoq: {
      'entity-type': 'reference',
      virtualType: 'ardoq_parent',
    },
    model,
  }) as APIParentChildReferenceAttributes;

// BE sets the child of a parent-child reference as source and the parent as
// target and uses as id `childId:parentId`. FE uses the opposite format.
export const toFEParentChildFormat = (
  reference: APIParentChildReferenceAttributes
): FEParentChildReferenceAttributes => ({
  ...reference,
  source: reference.target,
  target: reference.source,
  _id: `${reference.target}-${reference.source}`,
});

/**
 * Ardoq-front generally use parentId to generate parent/child relationships,
 * however some endpoints will return explicit parent/child references.
 */
export const isSyntheticParentChildReference = (
  reference: APIReferenceAttributes | APIParentChildReferenceAttributes
): reference is APIParentChildReferenceAttributes => {
  return reference.type === MagicReferenceTypes.syntheticParentChild;
};

/**
 * Implicit reference-types are available in ardoq-front auto-magically
 */
export const isImplicitReference = (reference: APIReferenceAttributes) => {
  return reference.type === MagicReferenceTypes.implicit;
};
